import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";

export const FloatingCallBar = () => {
  const { t } = useLang();
  const waUrl =
    "https://wa.me/41766344242?text=" + encodeURIComponent(t.floating.waText);

  return (
    <>
      <motion.div
        initial={{ y: 90 }}
        animate={{ y: 0 }}
        transition={{ delay: 1.8, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        data-testid="floating-quick-call-bar"
        className="fixed inset-x-0 bottom-0 z-50 flex gap-2 border-t border-amber-400/20 bg-[#0B0B0F]/90 p-3 backdrop-blur-xl md:hidden"
      >
        <a
          href="tel:+41766344242"
          data-testid="floating-call-button"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-amber-400 py-3.5 font-display text-sm font-extrabold uppercase tracking-wide text-black"
        >
          <Phone className="h-4 w-4" />
          {t.floating.call}
        </a>
        <a
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          aria-label="WhatsApp"
          className="flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3.5 font-display text-sm font-extrabold uppercase tracking-wide text-black"
        >
          <MessageCircle className="h-4 w-4" />
          {t.floating.whatsapp}
        </a>
      </motion.div>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 16 }}
        className="fixed bottom-8 right-8 z-50 hidden flex-col gap-3 md:flex"
      >
        <a
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button-desktop"
          aria-label="WhatsApp"
          className="flex h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_0_40px_rgba(37,211,102,0.3)] transition-transform duration-300 hover:scale-110"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
        <a
          href="tel:+41766344242"
          data-testid="floating-call-button-desktop"
          aria-label="Chiama Taxi Bellinzona"
          className="gold-glow flex h-16 w-16 items-center justify-center rounded-full bg-amber-400 text-black transition-transform duration-300 hover:scale-110"
        >
          <Phone className="h-6 w-6" />
        </a>
      </motion.div>
    </>
  );
};
